import React, {
    forwardRef,
    InputHTMLAttributes,
    useEffect,
    useRef,
    useState,
} from 'react';
import {
    AutoComplete,
    IconContainer,
    AutoCompleteList,
    AutoCompleteItem,
    Container,
    InputIcon,
    TextInput,
    VisualContainer
} from './styles';
import { faAngleUp, faTimes } from '@fortawesome/free-solid-svg-icons';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

// @ts-ignore
interface AppSearchInputProps extends InputHTMLAttributes<HTMLTextAreaElement> {
    value: string;
    onChange: (value: string) => void;
    autoCompleteData: {key: string, value: string}[]
    onEnter: () => void
}


const AppSearchInout = forwardRef<HTMLTextAreaElement, AppSearchInputProps>(({ autoCompleteData, value: externalValue, onChange, onEnter, ...props }, ref) => {

    const refAutoCompleteContainer = useRef<HTMLDivElement>(null);
    const [isOpenAutoComplete, setIsOpenAutoComplete] = useState<boolean>(false)
    const [value, setValue] = useState<string>()
    const [rows, setRows] = useState<number>(1);
    const [textAreaScrollHeight, setTextAreaScrollHeight] = useState<number>(38);
    const [visualContainerHeight, setVisualContainerHeight] = useState<number>(0);
    const handleClickOutside = (event: MouseEvent) => {
        if (refAutoCompleteContainer.current && !refAutoCompleteContainer.current.contains(event.target as Node)) {
            setIsOpenAutoComplete(false);
        }
    };

    const textareaRef = useRef<HTMLTextAreaElement>(null);


    useEffect(() => {
        if(externalValue !== value){
            setValue(externalValue)
        }
    }, [externalValue, value]);

    useEffect(() => {
        if (isOpenAutoComplete) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [isOpenAutoComplete]);


    const handleClickInput = () => {
        setIsOpenAutoComplete(true);
    }

    const handleClickItem = (item: {key: string, value: string}) => {
        const { value } = item;
        internalChange(value)
        setTimeout(() => {
            adjustTextHeight()
        }, 10)
        setIsOpenAutoComplete(false);
    }


    const internalChange = (value: string) => {
        setValue(value)
        if(onChange && typeof onChange === 'function')
            onChange(value)
    }

    const adjustTextHeight = () => {
        const textarea = textareaRef.current;
        if(textarea){
            textarea.rows = 1; // Reseta para evitar que o `scrollHeight` fique travado
            textarea.rows = Math.floor(textarea.scrollHeight / 23)
            setTextAreaScrollHeight(Math.max(textarea.scrollHeight, 38))
        }
    }

    const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        const { value } = e.target
        adjustTextHeight()
        internalChange(value)
    }


    const handleClickIcon = () => {
        if(value != null && value.trim() !== ""){
            internalChange("")
        }
    }


    const handleKeyDown = (event: React.KeyboardEvent<HTMLTextAreaElement>) => {
        if (event.key === 'Enter' && !event.shiftKey) {
            event.preventDefault();
            setIsOpenAutoComplete(false)
            if(onEnter && typeof  onEnter === 'function'){
                onEnter()
            }
        }
    };

    useEffect(() => {
        const handleResize = () => {
            adjustTextHeight();
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, [textareaRef.current]);


    useEffect(() => {
        let timeOut = null;
        if(textareaRef.current){
            timeOut = setTimeout( () => {
                adjustTextHeight();
            }, 100)
        }

        return () => {
            if(timeOut != null)
                clearTimeout(timeOut)
        }
    }, [autoCompleteData, externalValue, onChange, props]);


    useEffect(() => {
        if(isOpenAutoComplete && autoCompleteData?.length > 0 && refAutoCompleteContainer?.current){
            setVisualContainerHeight(refAutoCompleteContainer?.current.clientHeight)
        }else{
            setVisualContainerHeight(0)
        }
    }, [autoCompleteData, isOpenAutoComplete, refAutoCompleteContainer]);


    // @ts-ignore
    return (
        <Container>
            <TextInput
                {...props}
                onKeyDown={handleKeyDown}
                className="b-tema20 cortxt foco"
                rows={1}
                ref={(el: HTMLTextAreaElement|null) => {
                    // @ts-ignore
                    textareaRef.current = el;
                    if (typeof ref === "function") ref(el);
                    else if (ref) {
                        ref.current = el;
                    }
                }}
                value={value}
                onChange={handleChange}
                onClick={handleClickInput}
            />
            {
                // eslint-disable-next-line no-nested-ternary
                value != null && value.trim() !== "" && !isOpenAutoComplete ? (
                    <IconContainer style={{cursor: 'pointer'}} onClick={handleClickIcon}>
                        <InputIcon icon={faTimes as IconProp} />
                    </IconContainer>
                ) : isOpenAutoComplete && autoCompleteData && autoCompleteData.length > 0 ? (
                    <IconContainer>
                        <InputIcon icon={faAngleUp as IconProp} />
                    </IconContainer>
                ) : (
                    <IconContainer />
                )
            }
            {
                isOpenAutoComplete && autoCompleteData && autoCompleteData.length > 0 ? (
                    <AutoComplete
                        //@ts-ignore
                        top={`${(textAreaScrollHeight) + 2}px`}
                        ref={refAutoCompleteContainer}>
                        <AutoCompleteList>
                            {
                                autoCompleteData.map((item, index) => (
                                    <AutoCompleteItem
                                        onClick={e => handleClickItem(item)}
                                        key={item.key}>{item.value}
                                    </AutoCompleteItem>
                                ))
                            }
                        </AutoCompleteList>
                    </AutoComplete>
                ) : ''
            }

            <VisualContainer style={{
                height: visualContainerHeight + textAreaScrollHeight,
            }} />
        </Container>
    )
});

AppSearchInout.displayName = "AppSearchInout";

export default AppSearchInout;
